"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenterDetailRequest = void 0;
var CenterDetailRequest = /** @class */ (function () {
    function CenterDetailRequest() {
    }
    return CenterDetailRequest;
}());
exports.CenterDetailRequest = CenterDetailRequest;
;
//# sourceMappingURL=centerDetail.request.js.map